export const MAX_FREE_TEXT_LENGTH = 2000;
